import { mergeDeep, crossBrowserFocus } from '../util';
import { FC_Accessibility_LegendEnabled } from './legendEnabled';

class FC_Accessibility_MultiSeries extends FC_Accessibility_LegendEnabled {
    constructor(svgRoot, chartInstance, alternateTexts, config) {
        super(svgRoot,chartInstance,alternateTexts,config);

        this.addAxisInformation();
    }

    /**
     * Make multi series chart accessible
     */
    makeMultiSeriesAccessible() {
        //Make the legend accessible
        this.makeLegendAccessible();

        //Get chart plot points
        let dataSet = this.chartInstance.apiInstance.getDatasets();

        let categoryLength = this.chartData.categories[0].category.length;
        let seriesLength = this.chartData.dataset.length;
        let dataLength = this.chartData.dataset && this.chartData.dataset.length > 0 ? this.chartData.dataset[0].data.length : 0;

        //All multi series chart has series name

        //Bubble chart has x,y,z value and also name of a bubble can be specified
        let bubblePlotProperties = (i,j) => {
            let plotStat = {};
            //x value of bubble
            plotStat['{xValue}'] = this.chartData.dataset[i].data[j].x || '';
            //y value of bubble
            plotStat['{yValue}'] = this.chartData.dataset[i].data[j].y || '';
            //z value of bubble
            plotStat['{zValue}'] = this.chartData.dataset[i].data[j].z || '';
            //label of the bubble
            plotStat['{bubbleName}'] = this.chartData.dataset[i].data[j].name || '';
            //Series name
            plotStat['{seriesName}'] = this.chartData.dataset[i].seriesname || '';

            return plotStat;
        };

        //Scatter chart has x and y value
        let scatterPlotProperties = (i,j) => {
            let plotStat = {};
            //x value of bubble
            plotStat['{xValue}'] = this.chartData.dataset[i].data[j].x || '';
            //y value of bubble
            plotStat['{yValue}'] = this.chartData.dataset[i].data[j].y || '';
            //Series name
            plotStat['{seriesName}'] = this.chartData.dataset[i].seriesname || '';

            return plotStat;
        };

        //For all other supported multi series chart label and value is present
        let defaultMultiSeriesPlotPorperties = (i,j) => {
            let plotStat = {};
            //Label
            plotStat['{label}'] = this.chartData.categories[0].category[j].label || '';
            //value
            plotStat['{value}'] = this.chartData.dataset[i].data[j].value;
            //Formatted value
            plotStat['{formattedValue}'] = this.chartInstance.formatNumber(this.chartData.dataset[i].data[j].value);
            //Series
            plotStat['{seriesName}'] = this.chartData.dataset[i].seriesname || '';

            return plotStat;
        };

        //Based on the chart type, property formatter is decided
        let propertyFormatter = undefined;
        switch(this.chartType) {
            case "scatter":
                propertyFormatter = scatterPlotProperties;
                break;
            case "bubble":
                propertyFormatter = bubblePlotProperties;
                break;
            default:
                propertyFormatter = defaultMultiSeriesPlotPorperties;
                break;
        }

        let alternateTextsPlot;

        //Tab index and aria attribute is inserted for each plot point
        for(let i=0; i<seriesLength; i++) {
            for(let j=0; j<dataLength; j++) {
                let plotStat = propertyFormatter.call(this, i, j);

                plotStat['{plotIndex}'] = j+1;
                plotStat['{seriesIndex}'] = i+1;
                plotStat['{totalPlots}'] = dataLength;
                plotStat['{totalSeries}'] = seriesLength;
                alternateTextsPlot = this.alternateTexts.plot;
                if ((dataSet[i].components.data[j].config.setLink && dataSet[i].components.data[j].config.setLink !== "") || (dataSet[i].components.data[j].config.link && dataSet[i].components.data[j].config.link !== "")) {
                  alternateTextsPlot += " This is a clickable plot";
                }

                //this.addTabIndexAndSetAria(plots[i].children[j], this.alternateTexts.plot, extend(this.chartPropertyMap, plotStat), i==0 && j==0 ? "0" : "-1");
                this.addTabIndexAndSetAria(dataSet[i].components.data[j].graphics.element &&  dataSet[i].components.data[j].graphics.element.node, alternateTextsPlot, mergeDeep(this.chartPropertyMap, plotStat), i==0 && j==0 ? "0" : "-1");
            }
        }

        let plotIndex = -1, seriesIndex = 0;
        function plotSelectOnKeyPress(event) {
            if(!this.isAllLegendItemHidden()) {
                let keyCaptured = false, elemVisible = false, limitExceeded = false;

                while(!elemVisible) {
                    switch(event.keyCode) {
                        case 37:
                            //left arrow
                            if(plotIndex > 0)
                                --plotIndex;
                            else
                                limitExceeded = true;

                            keyCaptured = true;
                            break;
                        case 39:
                            if(plotIndex < dataLength - 1)
                                ++plotIndex;
                            else
                                limitExceeded = true;

                            keyCaptured = true;
                            break;
                        case 38:
                            //up arrow
                            if(seriesIndex > 0)
                                --seriesIndex;
                            else
                                limitExceeded = true;

                            keyCaptured = true;
                            break;
                        case 40:
                            //down arrow
                            if(seriesIndex < seriesLength - 1)
                                ++seriesIndex;
                            else
                                limitExceeded = true;

                            keyCaptured = true;
                            break;
                        case 13:
                            //Enter
                        case 32:
                            //spacebar
                            this.chartInstance.apiInstance.getDatasets()[seriesIndex]._firePlotEvent('fc-click', plotIndex < 0 ? 0 : plotIndex, new Event('click'));
                            // keyCaptured = true;
                            break;
                    }

                    if(keyCaptured) {

                        if(limitExceeded)
                            break;

                        // if(plots[seriesIndex] && plots[seriesIndex].children && plots[seriesIndex].children.length > 0 && plots[seriesIndex].children[plotIndex] && getComputedStyle(plots[seriesIndex].children[plotIndex]).display != "none") {
                        //     elemVisible = true;
                        // } dataSet[i].components.data[j].graphics.element.node

                        if(dataSet[seriesIndex].components.data[plotIndex].graphics.element && getComputedStyle(dataSet[seriesIndex].components.data[plotIndex].graphics.element.node).display != "none") {
                            elemVisible = true;
                        }

                        if(!elemVisible && (event.keyCode == 37 || event.keyCode == 39) && this.isLegendItemHidden(seriesIndex)) {
                            ++seriesIndex;
                            plotIndex = -1;
                        }
                    }
                    else break;
                }

                if(keyCaptured && elemVisible) {
                    crossBrowserFocus(dataSet[seriesIndex].components.data[plotIndex].graphics.element.node);
                }
            }
        }

        //If first value of first series is focus by pressing tab then plotIndex is not updated
        dataSet[0].components.data[0].graphics.element && dataSet[0].components.data[0].graphics.element.node.addEventListener('focus', function(){
            plotIndex = seriesIndex = 0;
        });

        this.svgRoot.addEventListener('keydown', plotSelectOnKeyPress.bind(this), false);
    }
}

export default FC_Accessibility_MultiSeries;